import React from 'react';

function Icon({icon, title, ...props}) {
    return (
        <>
            <img src={`${process.env.PUBLIC_URL}/img/icons/${icon}.png`} alt="icon" {...props}/>
            {title ?? title}
        </>
    );
}

export default Icon;